import { useState } from "react";
import { Typography } from "@mui/material";
import CustomFormLabel from "@components/FormItem/FormItem.styles";
import Input from "@components/Input/Input";
import { useTranslation } from "react-i18next";
import { usePortServicesFlow } from "../context/PortServicesFlowContext";

const LANG_BASE = "vessel-call.port-services";
const POSITIVE_INTEGER_PATTERN = /^\d*$/;
const ADDITIONAL_NUMBER_OF_SKIPS_MAX_DIGITS = 6;

const AdditionalSkips = () => {
  const { setAdditionalNumberOfSkips, errors, setErrors } = usePortServicesFlow();
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (value === "") {
      setInputValue("");
      setAdditionalNumberOfSkips(undefined);

      if (errors.additionalNumberOfSkips) {
        setErrors({
          ...errors,
          additionalNumberOfSkips: undefined,
        });
      }
      return;
    }
    if (!POSITIVE_INTEGER_PATTERN.test(value)) return;

    if (value.length > ADDITIONAL_NUMBER_OF_SKIPS_MAX_DIGITS) {
      setErrors({
        ...errors,
        additionalNumberOfSkips: t("form-validation.max-length-digits", {
          label: t(`${LANG_BASE}.fields.additional-number-of-skips`),
          maxDigits: ADDITIONAL_NUMBER_OF_SKIPS_MAX_DIGITS,
        }),
      });
      return;
    }

    const numberValue = Number(value);

    setInputValue(String(numberValue));
    setAdditionalNumberOfSkips(Number.isNaN(numberValue) ? undefined : numberValue);

    if (errors.additionalNumberOfSkips) {
      setErrors({
        ...errors,
        additionalNumberOfSkips: undefined,
      });
    }
  };

  const handleBlur = () => {
    if (!errors.additionalNumberOfSkips) return;

    setErrors({
      ...errors,
      additionalNumberOfSkips: undefined,
    });
  };

  return (
    <div className="flex flex-col gap-2">
      <CustomFormLabel data-testid="additionalNumberOfSkips-label">
        {t(`${LANG_BASE}.fields.additional-number-of-skips`)}
      </CustomFormLabel>
      <Input
        type="text"
        inputMode="numeric"
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        testId="additionalNumberOfSkips-input"
        sx={{ width: "100%" }}
        placeholder={t(`${LANG_BASE}.fields.additional-number-of-skips`)}
        fullWidth
      />
      {errors.additionalNumberOfSkips && (
        <Typography variant="caption" color="error" sx={{ mt: 0.5, display: "block" }}>
          {errors.additionalNumberOfSkips}
        </Typography>
      )}
    </div>
  );
};

export default AdditionalSkips;
